import { __module as nonIterableRest } from '../../../../_virtual/nonIterableRest.js';

(function (module) {
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (nonIterableRest));
//# sourceMappingURL=nonIterableRest.js.map
